export enum DokumanTuru {
    vekaletname=1,
    pasaport,
    ehliyet,
    nufus_cuzdani,
    imza_surkusu,
    avukat_kimlik_karti,
    cek,
    senet,
    dayanak,
    diger

}

export enum DokumanTuruLabel{
    "Vekaletname"=1,
    "Pasaport",
    "Ehliyet",
    "Nüfus Cüzdanı",
    "İmza Sürküsü",
    "Avukat Kimlik Kartı",
    "Çek",
    "Senet",
    "Dayanak",
    "Diğer"
}